import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './component/helpers/store';
import './i18n';
// import { commonClass } from './component/helpers/commonClass';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import { history } from './component/helpers/history';
import { commonClass } from './component/helpers/commonClass';
import { appVariables } from './component/helpers/appVariables';

if (process.env.REACT_APP_MODE != 'development') {
  disableReactDevTools();
}

// const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
// console.log(width);
// const mobileViewWidth = 900;
// let locationurl = "";
// let d=process.env.REACT_APP_DESKTOP_URL;
// let d1=process.env.REACT_APP_MOBILE_URL;
// if (width < mobileViewWidth) {//check mobile
//   //mobile  
//   if (process.env.REACT_APP_MOBILE_URL && window.location.href.toLowerCase().indexOf('mobile') < 0) {
//     locationurl = process.env.REACT_APP_MOBILE_URL;
//   }
// }
// else {
//   //Desktop  
//   if (process.env.REACT_APP_DESKTOP_URL && window.location.href.toLowerCase().indexOf('mobile') >= 0) {
//     locationurl = process.env.REACT_APP_DESKTOP_URL;
//   }
// }
//  if (locationurl != "") 
//  { window.location = locationurl; }

//  if ((window.location.host.indexOf('www') >= 0 || window.location.protocol == 'http:') && process.env.REACT_APP_MODE == "production") {
//   window.location = "https://" + window.location.host.replace("www.", "") + window.location.pathname + window.location.search;
// }

if (process.env.REACT_APP_MODE != 'development') {
  disableReactDevTools();
}

history.push = async (path) => {
  try {
    const lang = window.location.pathname.split('/');
    let langbaseurl = ""
    if (lang.length >= 2) {
      let countryData = {};
      if (localStorage.getItem('cloc') != null) {
        try {
          countryData = JSON.parse(localStorage.getItem('cloc'));
        } catch (error) {
          console.log(error);
          countryData = await GetCountry();
        }
      }
      else {
        countryData = await GetCountry();
      }
      let Langname = '';
      // localStorage.setItem('cloc', JSON.stringify(countryData));
      const storedLang = localStorage.getItem('language');
      if (storedLang) {
        Langname = JSON.parse(storedLang);
      } else {
        Langname = getCookie('gtlang');
      }
      langbaseurl = `${countryData.country}-${Langname}`;
    } else {
      langbaseurl = lang[1]
    }
    let state = path.state ? path.state : {};
    path = path.pathname ? path.pathname : path;
    path = SetUrl(path)
    // if (path == '/slotgame') {
    //   let _formobj = { url: state.WindowUrl, userid: state.Userid, spintype: state.spintype, gameid: state.gameid, type: state.type }
    //   localStorage.setItem('slotgame', JSON.stringify(_formobj))
    // }
    if (path == "/resetpassword") {
      sessionStorage.setItem('popupopen', JSON.stringify(appVariables.PopUpFlags.Forgotpassword))
      window.location.href = `/${langbaseurl}/big-ticket`;
      return
    }
    else if (path.toLowerCase() == "/login") {
      let string_value = appVariables.PopUpFlags.Login;
      sessionStorage.setItem('popupopen', JSON.stringify(appVariables.PopUpFlags.Login))
      window.location.href = `/${langbaseurl}/big-ticket`;
      return
    }
    else if (path.toLowerCase() == "/reenterpassword") {
      sessionStorage.setItem('popupopen', JSON.stringify(appVariables.PopUpFlags.Reenterpassword))
      window.location.href = `/${langbaseurl}/big-ticket`;
      return
    }
    else if (path.toLowerCase() == "/registerthankyou") {
      window.location.href = `/${langbaseurl}/registerthankyou?flag=${state.Navflag}`;
      return
    }

    window.location.href = `/${langbaseurl}${path}`;

  } catch (error) {
    window.location.href = `/${path}`;
  }
};

const getCookie = (name) => {
  try {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    let lang_val = process.env.REACT_APP_DEFAULTLANGUAGE;
    if (parts.length >= 2) {
      let lst = value.split(`;`);
      let fobj = lst.filter(a => a.indexOf('gtlang=') >= 0);
      if (fobj && fobj.length > 0) {
        let fobj1 = fobj[fobj.length - 1].split(`=`);
        lang_val = fobj1[1];
      }
    }
    return lang_val;
  }
  catch (ex) {
    return process.env.REACT_APP_DEFAULT_LANGUAGE;
  }
};


const GetCountry = async () => {
  try {
    const response = await commonClass.GetUserCountry();
    const data = await response.json();
    localStorage.setItem('cloc', JSON.stringify(data));
    return data;
  } catch (error) {
    if (localStorage.getItem('cloc')) {
      let df = JSON.parse(localStorage.getItem('cloc'));
      return df;
    }
    else {
      let df = { country: "IN" }
      localStorage.setItem('cloc', JSON.stringify(df));
      return df;
    }
  }
};

if (process.env.REACT_APP_MODE == "production") {
  console.log = () => { };
  console.error = () => { };
  console.debug = () => { };
}

const SetUrl = (path) => {
  let Cpath = path;
  let storedLang = localStorage.getItem('cloc');
  if (storedLang) {
    storedLang = JSON.parse(storedLang);
  }

  // if (!storedLang || !storedLang.country || storedLang.country.toLowerCase() != 'my') {
  //   return Cpath;
  // }

  switch (Cpath.toLowerCase()) {
    case '/home':
    case '/':
      if (storedLang && storedLang.country && storedLang.country.toLowerCase() == 'my') {
        return '/lottery-ticket'
      }
      else {
        return '/big-ticket'
      }
    case '/lucky1':
      if (storedLang && storedLang.country && storedLang.country.toLowerCase() == 'my') {
        return '/lottery-ticket/lucky1-1d'
      }
      else {
        return '/big-ticket/lucky1'
      }
    case '/rush3':
      if (storedLang && storedLang.country && storedLang.country.toLowerCase() == 'my') {
        return '/lottery-ticket/rush3-3d'
      }
      else {
        return '/big-ticket/rush3'
      }
    case '/dream5':
      if (storedLang && storedLang.country && storedLang.country.toLowerCase() == 'my') {
        return '/lottery-ticket/dream5-5d'
      }
      else {
        return '/big-ticket/dream5'
      }
    case '/magic5':
      if (storedLang && storedLang.country && storedLang.country.toLowerCase() == 'my') {
        return '/lottery-ticket/magic5-5d'
      }
      else {
        return '/big-ticket/magic5'
      }
    case '/fortune6':
      if (storedLang && storedLang.country && storedLang.country.toLowerCase() == 'my') {
        return '/lottery-ticket/fortune6-6d'
      }
      else {
        return '/big-ticket/fortune6'
      }
    case '/super6':
      if (storedLang && storedLang.country && storedLang.country.toLowerCase() == 'my') {
        return '/lottery-ticket/super6-6d'
      }
      else {
        return '/big-ticket/super6'
      }

    // Draws Page
    case '/lucky1draws':
      if (storedLang && storedLang.country && storedLang.country.toLowerCase() == 'my') {
        return '/1d-live-results-lucky1draws'
      }
      else {
        return '/live-results-lucky1draws'
      }
    case '/rush3draws':
      if (storedLang && storedLang.country && storedLang.country.toLowerCase() == 'my') {
        return '/3d-live-results-rush3draws'
      }
      else {
        return '/live-results-rush3draws'
      }
    case '/dream5draws':
      if (storedLang && storedLang.country && storedLang.country.toLowerCase() == 'my') {
        return '/5d-live-results-dream5draws'
      }
      else {
        return '/live-results-dream5draws'
      }
    case '/magic5draws':
      if (storedLang && storedLang.country && storedLang.country.toLowerCase() == 'my') {
        return '/5d-live-results-magic5draws'
      }
      else {
        return '/live-results-magic5draws'
      }
    case '/fortune6draws':
      if (storedLang && storedLang.country && storedLang.country.toLowerCase() == 'my') {
        return '/6d-live-results-fortune6draws'
      }
      else {
        return '/live-results-fortune6draws'
      }
    case '/super6draws':
      if (storedLang && storedLang.country && storedLang.country.toLowerCase() == 'my') {
        return '/6d-live-results-super6draws'
      }
      else {
        return '/live-results-super6draws'
      }
    case '/othersdraws':
      if (storedLang && storedLang.country && storedLang.country.toLowerCase() == 'my') {
        return '/5d-live-results-othersdraws'
      }
      else {
        return '/live-results-othersdraws'
      }
    case '/promotion':
      if (storedLang && storedLang.country && storedLang.country.toLowerCase() == 'my') {
        return '/live-results-promotion'
      }
      else {
        return '/live-results-promotion'
      }
  }
  return Cpath;
}

// const { setItem } = localStorage;
// localStorage.setItem = function (key, value) {
//   console.log('localStorage.setItem', key);
//   let lstrencryptdt = "";
//   if (key == 'user') {
//     try {
//       lstrencryptdt = commonClass.encrypt(value);
//     }
//     catch (ex) {
//       lstrencryptdt = value
//     }
//   }
//   else {
//     lstrencryptdt = value;
//   }
//   setItem.call(this, key, lstrencryptdt);
// };

// if (process.env.REACT_APP_MODE == "production") {
//   function ctrlShiftKey(e, t) {
//     return e.ctrlKey && e.shiftKey && e.keyCode === t.charCodeAt(0)
//   }
//   document.addEventListener("contextmenu", (e => e.preventDefault())),
//     document.onkeydown = e => {
//       if (123 === event.keyCode || ctrlShiftKey(e, "I") || ctrlShiftKey(e, "J") || ctrlShiftKey(e, "C") || e.ctrlKey && e.keyCode === "U".charCodeAt(0))
//         return !1
//     }
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    {/* <Suspense fallback={<span>Loading...</span>}> */}
    <Suspense>
      <App />
    </Suspense>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
